import { useEventsSubscriber } from 'event-bus';
import { PROJECT_NOTE_CREATED_EVENT } from 'nekst-api';
import { toastService } from './toastService';

/**
 * Project Notes Events Toast Listener
 * Subscribes to project note creation events and displays toast notifications
 * Only shows toast when on the project tasks page
 */
export default function ProjectNotesEventsToasts() {
  useEventsSubscriber(
    'ProjectNotesEventsToasts',
    {
      [PROJECT_NOTE_CREATED_EVENT]: () => {
        // Check if we're on a transaction tasks page (URL pattern: /transactions/{id})
        const isTransactionTasksPage = /^\/transactions\/\d+$/.test(window.location.pathname);

        if (isTransactionTasksPage) {
          toastService.createToast('Transaction note created');
        }
      },
    },
    []
  );

  return null;
}
